import { globalConstants, studentConstants } from "../../constants";

const initialState = {
  page: {},
  pageData: [],
  openModal: false,
  viewData: {},
  stats: {
    noOfStudents: 0,
    noOfHours: 0,
    instructorSports: [],
    freelanceSports: [],
  },
  studentsData: [],
  centerCourseData: [],
  allCourses: [],
  systemCourses: [],
  allQuestions: [],
  viewFeedback: {},
};

const CourseReducer = (state = initialState, action) => {
  switch (action.type) {
    case studentConstants.GET_PAGINATION_DATA + globalConstants.SUCCESS:
      return {
        ...state,
        studentsData: action.data,
      };

    case studentConstants.GET_STATS + globalConstants.SUCCESS:
      return {
        ...state,
        stats: {
          ...state.stats,
          noOfStudents: action.data?.noOfStudents || 0,
          noOfHours: action.data?.noOfHours || 0,
          instructorSports: action.data?.instructorSports || [],
          freelanceSports: action.data?.freelanceSports || [],
        },
      };

    case studentConstants.VIEW_STUDENT + globalConstants.SUCCESS:
      return {
        ...state,
        viewData: action.data,
      };

    case studentConstants.INITIAL_STATE + globalConstants.SUCCESS:
      return {
        ...state,
        viewData: {},
      };

    case studentConstants.GET_CENTER_PAGINATION_DATA + globalConstants.SUCCESS:
      return {
        ...state,
        centerCourseData: action.data,
      };

    case studentConstants.GET_ALL_COURSES + globalConstants.SUCCESS:
      return {
        ...state,
        allCourses: action.data,
      };

    case studentConstants.GET_COURSES_BY_SYSTEM_ID + globalConstants.SUCCESS:
      return {
        ...state,
        systemCourses: action.data,
      };

    case studentConstants.GET_ALL_QUESTIONS + globalConstants.SUCCESS:
      return {
        ...state,
        allQuestions: action.data,
      };

    case studentConstants.GET_FEEDBACK_BY_ID + globalConstants.SUCCESS:
      return {
        ...state,
        viewFeedback: action.data,
      };

    default:
      return state;
  }
};

export default CourseReducer;
